import { format } from "date-fns";
import React from "react";
import { FlexWrap } from "../../../../components";
import {
  ActionsContainer,
  PracticeGuideRowContainer,
  TableRowItemWrapper,
  StatusBadge,
} from "../../styled";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { getVideoType } from "../practiceGuide/utils/getVideoType";
import VideoThumbnail from "./VideoThumbnail";

export function TipsAndDrillsRow({ data, onDelete, onEdit, onCopy }) {
  const { loopVideo, title, status, createdAt, type, author } = data;
  const iconStyle = { cursor: "pointer", fontSize: "25px" };

  return (
    <PracticeGuideRowContainer>
      <TableRowItemWrapper width="132px">
        {loopVideo && loopVideo.videoPath ? (
          <VideoThumbnail
            src={loopVideo.videoPath}
            type={getVideoType(loopVideo.videoPath)}
            className="bg-black w-full max-w-full block object-cover h-[87px]"
          />
        ) : (
          <img
            className="w-full object-cover h-auto block"
            src="https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png"
            alt={title}
            height="87"
          />
        )}
      </TableRowItemWrapper>
      <TableRowItemWrapper width="200px">
        <div>{title}</div>
      </TableRowItemWrapper>
      <TableRowItemWrapper width="200px">
        <div>Tips And Drills Video</div>
      </TableRowItemWrapper>
      <TableRowItemWrapper width="100px">
        <div>{author}</div>
      </TableRowItemWrapper>
      <TableRowItemWrapper width="100px">
        <div>{format(createdAt, "MM/dd/yyyy")}</div>
      </TableRowItemWrapper>
      <TableRowItemWrapper width="100px">
        <StatusBadge status={status}>{status}</StatusBadge>
      </TableRowItemWrapper>
      <TableRowItemWrapper width="100px">
        <ActionsContainer>
          <EditIcon onClick={onEdit} style={iconStyle} />
          <DeleteIcon onClick={onDelete} style={iconStyle} />
          <FileCopyIcon onClick={onCopy} style={iconStyle} />
        </ActionsContainer>
      </TableRowItemWrapper>
    </PracticeGuideRowContainer>
  );
}
